import script from "./CampoSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoSelect.vue?vue&type=script&setup=true&lang=js"

import "./CampoSelect.vue?vue&type=style&index=0&id=2b2a6ec3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2a6ec3"]])

export default __exports__